/*
 * HomeReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */

import produce from "immer";
import {
  LOADER_STATUS,
  PROFILE_INFO,
  SET_VARIANCE_DATA,
  SET_ITCREPORT_DATA,
  SET_CLEAR_GRAPH
} from "./constants";

// The initial state of the App
export const initialState = {
  loaderStatus: false,
  profileData: [],
  varianceData: [],
  ITCReportData: []
};

/* eslint-disable default-case, no-param-reassign */
const GSTR3BVSGSTR2AReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus
      };
    case PROFILE_INFO:
      return {
        ...state,
        profileData: action.profileData
      };
    case SET_VARIANCE_DATA:
      return {
        ...state,
        varianceData: action.varianceData
      };
    case SET_ITCREPORT_DATA:
      return {
        ...state,
        ITCReportData: action.ITCReportData
      };
    case SET_CLEAR_GRAPH:
      return {
        ...state,
        ITCReportData: [],
        varianceData: []
      };
    default:
      return state;
  }
};

export default GSTR3BVSGSTR2AReducer;
